import { Link, useLocation } from "react-router-dom";
import type { NavItem } from "./Header";

function NavLink({
  item,
  isActive,
  lightText,
}: {
  item: NavItem;
  isActive: boolean;
  lightText?: boolean;
}) {
  const base =
    "rounded-full px-4 py-2 text-base font-semibold tracking-wide transition-all inline-flex items-center gap-2";

  if (item.onClick) {
    return (
      <button
        onClick={item.onClick}
        className={`${base} ${
          lightText
            ? "text-white hover:bg-white/10 hover:text-white"
            : "text-[#1F2240] hover:bg-[#E10F18]/10 hover:text-[#E10F18]"
        }`}
      >
        {item.label}
      </button>
    );
  }

  return (
    <Link
      to={item.to || "/"}
      className={`${base} ${
        isActive
          ? "bg-[#E10F18] text-white shadow-sm"
          : lightText
            ? "text-white hover:bg-white/10 hover:text-white"
            : "text-[#1F2240] hover:bg-[#E10F18]/10 hover:text-[#E10F18]"
      }`}
    >
      {item.label}
      {item.badge != null && item.badge > 0 && (
        <span className={`flex h-5 min-w-[20px] items-center justify-center rounded-full px-1.5 text-xs font-bold ${
          isActive ? "bg-white/25 text-white" : "bg-[#E10F18] text-white"
        }`}>
          {item.badge > 99 ? "99+" : item.badge}
        </span>
      )}
    </Link>
  );
}

type Props = {
  items: NavItem[];
  isBar?: boolean;
  /** Menú con texto blanco y sin fondo blanco (para header sobre hero) */
  lightText?: boolean;
};

export function HeaderNavPill({ items, isBar, lightText }: Props) {
  const location = useLocation();

  return (
    <div
      className={`inline-flex items-center gap-1 overflow-visible px-5 py-1 transition-all duration-300 ${
        isBar
          ? "rounded-xl bg-transparent"
          : lightText
            ? "rounded-full bg-white/10 shadow-[0_4px_20px_rgba(0,0,0,0.15)] ring-1 ring-white/20 backdrop-blur-sm"
            : "rounded-full bg-white/95 shadow-[0_4px_20px_rgba(15,23,42,0.08)] ring-1 ring-black/5 backdrop-blur-sm"
      }`}
    >
      {items.map((item) => (
        <NavLink
          key={item.label}
          item={item}
          isActive={!!(item.to && location.pathname === item.to)}
          lightText={lightText}
        />
      ))}
    </div>
  );
}
